export function ItemGenericWarning() {
  return (
    <div className='text-destructive border-destructive/50 bg-destructive/10 rounded-md border p-3 text-sm'>
      Could not display item
    </div>
  )
}
